import {GetCuroCodes_getCuroCodes} from '../../../schema-types/GetCuroCodes';
import {GoalFormValues} from './utils';

// export const UNDEFINED = 'Undefined';
// export const NO_LONGER_REQUIRED = 'No longer required';?

// export const setGoalStatusMarkers = ({
//   // statusData,
//   setStatusAtReviewMarkLabels,
//   values,
//   setStatusAtReviewIndex,
// }: {
//   // statusData: (GetCuroCodes_getCuroCodes | null)[];
//   setStatusAtReviewMarkLabels: React.Dispatch<React.SetStateAction<StatusAtReviewEnum[]>>;
//   values: GoalFormValues;
//   setStatusAtReviewIndex: React.Dispatch<React.SetStateAction<number>>;
// }) => {
//   // if (!statusData.length) {
//   //   return;
//   // }
//   // let markLabels = statusData.map((x) => x!.value);
//   // // removing the last status value 'No longer required', since it has its own checkbox now
//   // markLabels.pop();
//   // markLabels = [StatusAtReviewEnum.UNDEFINED, ...markLabels];

//   setStatusAtReviewMarkLabels(markLabels);

//   // load back data into status slider
//   if (values.statusAtReview === StatusAtReviewEnum.NO_LONGER_REQUIRED) {
//     // do nothing
//   } else if (!values.statusAtReview) {
//     setStatusAtReviewIndex(0);
//   } else {
//     const loadedIndex =
//       values.statusAtReview.toLowerCase() === 'undefined'
//         ? 0
//         : statusData.findIndex((x) => x?.value === values.statusAtReview) + 1;
//     setStatusAtReviewIndex(loadedIndex);
//   }
// };

export const setGoalPriorityMarkers = ({
  priorityData,
  setPriorityMarkLabels,
  values,
  setPriorityIndex,
}: {
  priorityData: (GetCuroCodes_getCuroCodes | null)[];
  setPriorityMarkLabels: React.Dispatch<React.SetStateAction<string[]>>;
  values: GoalFormValues;
  setPriorityIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  if (!priorityData.length) {
    return;
  }
  // This makes the priorities go from left to right in ascending order
  const prioritiesAscendingOrder = [...priorityData].reverse();

  // load back data into priority slider
  if (values.priority) {
    const loadedIndex =
      values.priority.toLowerCase() === 'undefined'
        ? 0
        : prioritiesAscendingOrder.findIndex((x) => x?.value === values.priority) + 1;
    setPriorityIndex(loadedIndex);
  }

  setPriorityMarkLabels([
    'Undefined',
    ...prioritiesAscendingOrder.map((x) => x?.value || ''),
  ]);
};
